export const createDefaultOptions = () => {
    return {filteredInfo: null, sortedInfo: null, hidden:{rating:false, styles:false}}
}